import { ExamRepository } from "repositories/ExamRepository";
import { ExamMLResult } from "types/ExamMLRestult";
import { AppThunk } from "../rootStore";
import {
  setMinMaxFrames,
  // setExamFrames,
  setLoading,
} from "./examMLResultSlice";
import { addRequest, removeRequest } from "../LoadingStore/loadingSlice";
import { Requests } from "../../types/requests";

  export const getMinAndMaxExamFrames =
  (id: string): AppThunk =>
  async (dispatch) => {
    try {
      const examRepository = ExamRepository.getInstance();

      dispatch(setLoading(true));
      dispatch(addRequest(Requests.getMinMaxFrames));
      const minAndMaxExamFrames = await examRepository.getMinAndMaxExamFrames(id);
     
        // @ts-ignore: Unreachable code error
      dispatch(setMinMaxFrames(minAndMaxExamFrames || ({} as ExamMLResult)));
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
      dispatch(removeRequest(Requests.getMinMaxFrames));
    }
};

// export const getExamFrames =
//   (examId = ""): AppThunk =>
//   async (dispatch) => {
//     try {
//       const examRepository = ExamRepository.getInstance();

//       dispatch(addRequest(Requests.getExamFrames));
//       const frames = await examRepository.getExamFrames(examId);

//       dispatch(setExamFrames(frames.items));
//     } catch (error) {
//       console.log(error);
//     } finally {
//       dispatch(removeRequest(Requests.getExamFrames));
//     }
//   };
